import { CheckCircleFilledOutlined, CheckCircleOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

interface CostBreakdownCompletedCellProps {
  completed?: boolean
}

export const CostBreakdownCompletedCell: FC<CostBreakdownCompletedCellProps> = ({ completed }) =>
  completed ? (
    <CheckCircleFilledOutlined className='text-tertiary-green-500' />
  ) : (
    <CheckCircleOutlined className='text-gray-600' />
  )
